import { FC } from "react";

import { useAssociationsInfoContext } from "../../../contexts/editableItemContext";
import { LocationBranch } from "../../../models";
import style from "./style.module.scss";
import { ToggleButton } from "./toggle";

interface BranchProps {
	branch: LocationBranch;
	marketerId: number;
	marketerEnabled: boolean;
	limitMarketerAssociations: boolean;
	readOnly?: boolean;
}

export const Branch: FC<BranchProps> = ({
	branch,
	marketerId,
	marketerEnabled,
	limitMarketerAssociations,
	readOnly,
}) => {
	const { updateBranch } = useAssociationsInfoContext();
	const { branchId, branchName, branchStateName, branchEnabled } = branch;

	const buttonDisabled = limitMarketerAssociations ? !marketerEnabled : marketerEnabled;
	const enabled = limitMarketerAssociations ? branchEnabled : branchEnabled && !marketerEnabled;

	return (
		<div className={enabled ? style.branchRowEnabled : style.branchRow}>
			<ToggleButton
				enabled={branchEnabled}
				disabled={buttonDisabled || readOnly}
				update={(u) => updateBranch(marketerId, branchId, u)}
			/>
			<span className={style.branchName}>
				{branchName} ({branchStateName})
			</span>
		</div>
	);
};
